import { useMemo } from 'react';

import { SelectDefaultValueType, SelectOptionType } from '../../Select';
import { SelectFieldProps, SelectFieldRequiredProps } from '../SelectField';
import { FetchCacheItemCategoriesItemCategoryType } from '../../../main/itemCategories/query/fetchCacheItemCategories.query';
import { FetchItemCategoriesSortTypes } from '../../../main/itemCategories/itemCategoriesTypes';

import { FETCH_CACHE_ITEM_CATEGORIES_QUERY } from '../../../main/itemCategories/query/fetchCacheItemCategories.query';

import { useCachePaginatedItemCategories } from '../../../main/itemCategories/hooks/useCachePaginatedItemCategories';

import { SelectField } from '../SelectField';

import { ItemCategoryCache } from '../../../main/itemCategories/ItemCategoryCache';

function ItemCategoriesSelectField<
  FormDataType,
  ValueType = SelectDefaultValueType
>({
  control,
  disabled,
  name,
  i18nLabel,
  i18nPlaceholder,
  labelClassName,
  error
}: Omit<
  SelectFieldProps<FormDataType, ValueType> &
    SelectFieldRequiredProps<FormDataType>,
  'options'
>) {
  const { itemCategories, itemCategoriesFetched } =
    useCachePaginatedItemCategories<FetchCacheItemCategoriesItemCategoryType>({
      query: FETCH_CACHE_ITEM_CATEGORIES_QUERY,
      cacheKey: ItemCategoryCache.indexCacheKey(),
      initialSort: [FetchItemCategoriesSortTypes.CREATED_AT_ASC]
    });

  const itemCategoriesOptions = useMemo<SelectOptionType<string>[]>(
    () =>
      itemCategories.map((cat) => ({
        label: cat.name,
        value: cat.id
      })),
    [itemCategories]
  );

  return (
    <SelectField
      control={control}
      disabled={disabled || !itemCategoriesFetched}
      error={error}
      i18nLabel={i18nLabel}
      i18nPlaceholder={i18nPlaceholder}
      labelClassName={labelClassName}
      name={name}
      options={itemCategoriesOptions}
    />
  );
}

export default ItemCategoriesSelectField;
